import React from "react";

import styles from "../../styles/Loader.module.css";

export default function CircleLoader() {
  return (
    <div className={styles.loader}>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
    </div>
  );
}


